module.exports = __webpack_public_path__ + "static/img/bg_mod_manufacture.ad377eef.jpg";